import { FORM_PATHS, openInModalOrPage } from '../../modals';

export const editPerson = person => (dispatch, getState) => {
    dispatch(openInModalOrPage(FORM_PATHS.EditPerson, person.personId, person, person.companyId));
};
